import { render, staticRenderFns } from "./ForbiddenKeywordsTable.vue?vue&type=template&id=fd3a7ae0&scoped=true"
import script from "./ForbiddenKeywordsTable.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsTable.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenKeywordsTable.vue?vue&type=style&index=0&id=fd3a7ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a7ae0",
  null
  
)

export default component.exports